/** The consumer's sent applications as stored (answers and consents), loaded only when asked for. */
import { useQuery } from '@tanstack/react-query';
import { consumerApi, consumerApplicationRecordKeys } from '../api/consumer-api';

export function useConsumerApplicationRecords(clientId: string, { enabled }: { enabled: boolean }) {
  return useQuery({
    queryKey: consumerApplicationRecordKeys.detail(clientId),
    queryFn: () => consumerApi.getApplicationRecords(clientId),
    enabled: enabled && !!clientId,
    // A sent application never changes.
    staleTime: Infinity,
  });
}
